import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommodityInfo } from '@mommy/models/ec/CommodityInfo.model';

@Component({
  selector: 'app-product-list-item2',
  templateUrl: './product-list-item2.component.html',
  styleUrls: ['./product-list-item2.component.scss'],
})
export class ProductListItem2Component implements OnInit {
  @Output() commodityOnClick = new EventEmitter<CommodityInfo>();

  _commodity: CommodityInfo;

  constructor() {}

  ngOnInit() {}

  get commodity(): any {
    return this._commodity;
  }

  @Input() set commodity(value: any) {
    console.log('commodity', value);
    if (value) {
      this._commodity = value;
    } else {
      this._commodity = {};
    }
  }

  commodityClick() {
    this.commodityOnClick.emit(this.commodity);
  }
}
